import React, { useEffect, useState } from "react";
import { Search, MapPin } from "lucide-react";
import client from "@/lib/api";
import useMeta from "@/lib/useMeta";
import ProductCard from "@/components/ProductCard";

export default function Browse() {
  const meta = useMeta();
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");
  const [city, setCity] = useState("all");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      client
        .get("/products", { params: { cat, city, q: q || undefined } })
        .then((r) => setProducts(r.data))
        .finally(() => setLoading(false));
    }, q ? 250 : 0);
    return () => clearTimeout(t);
  }, [cat, city, q]);

  return (
    <div dir="rtl">
      <div className="sticky top-0 z-20 px-4 pt-4 pb-3" style={{ background: "var(--k-paper)", borderBottom: "1px solid var(--k-line)" }}>
        <h1 className="font-head text-[18px] font-bold mb-3">تصفّح المنتجات</h1>
        <div className="flex items-center gap-2 rounded-2xl px-3.5 py-3" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
          <Search size={18} style={{ color: "var(--k-ink-soft)" }} />
          <input data-testid="browse-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="ابحث عن منتج، تاجر، مدينة…" className="bg-transparent border-0 outline-none w-full text-[14px]" />
        </div>
      </div>

      {/* city filter */}
      <div className="px-4 pt-3">
        <div className="flex items-center gap-1.5 mb-2 text-[12px] font-semibold" style={{ color: "var(--k-ink-soft)" }}>
          <MapPin size={14} /> المدينة
        </div>
        <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
          {[{ v: "all", l: "كل المدن" }, ...meta.cities.map((c) => ({ v: c, l: c }))].map((c) => {
            const active = city === c.v;
            return (
              <button key={c.v} data-testid={`city-chip-${c.v}`} onClick={() => setCity(c.v)} className="k-tap shrink-0 px-3 py-1.5 rounded-full text-[12px] font-semibold whitespace-nowrap" style={{ background: active ? "var(--k-gold)" : "var(--k-surface)", color: active ? "#fff" : "var(--k-ink-soft)", border: `1px solid ${active ? "var(--k-gold)" : "var(--k-line)"}` }}>
                {c.l}
              </button>
            );
          })}
        </div>
      </div>

      {/* category filter */}
      <div className="flex gap-2 px-4 pt-2 overflow-x-auto no-scrollbar">
        {[{ id: "all", name: "الكل" }, ...meta.categories].map((c) => {
          const active = cat === c.id;
          return (
            <button key={c.id} data-testid={`browse-cat-${c.id}`} onClick={() => setCat(c.id)} className="k-tap shrink-0 px-3.5 py-2 rounded-full text-[12.5px] font-semibold whitespace-nowrap" style={{ background: active ? "var(--k-ink)" : "var(--k-surface)", color: active ? "#fff" : "var(--k-ink-soft)", border: `1px solid ${active ? "var(--k-ink)" : "var(--k-line)"}` }}>
              {c.name}
            </button>
          );
        })}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2.5 px-4 md:px-6 pt-4 pb-6">
        {loading ? (
          Array.from({ length: 6 }).map((_, i) => <div key={i} className="rounded-2xl animate-pulse" style={{ height: 92, background: "var(--k-surface)", border: "1px solid var(--k-line)" }} />)
        ) : products.length ? (
          products.map((p) => <ProductCard key={p.id} p={p} list />)
        ) : (
          <div className="text-center py-14 md:col-span-2 xl:col-span-3" style={{ color: "var(--k-ink-soft)" }}>
            <Search size={38} className="mx-auto mb-3 opacity-50" />
            <p className="text-[13.5px]">لا توجد نتائج مطابقة</p>
          </div>
        )}
      </div>
    </div>
  );
}
